<template>
    <div>
        <picture v-if="rating=='GOOD'">
            <source srcset="/images/used/autotrader/good.webp" type="image/webp">
            <img :class="classes" src="/images/used/autotrader/good.png" alt="Autotrader rating - good price">
        </picture>
        <picture v-else-if="rating=='GREAT'">
            <source srcset="/images/used/autotrader/great.webp" type="image/webp">
            <img :class="classes" src="/images/used/autotrader/great.png" alt="Autotrader rating - great price">
        </picture>
        <picture v-else-if="rating=='LOW'">
            <source srcset="/images/used/autotrader/lower.webp" type="image/webp">
            <img :class="classes" src="/images/used/autotrader/lower.png" alt="Autotrader rating - low price">
        </picture>
        <picture v-else-if="rating=='FAIR'">
            <source srcset="/images/used/autotrader/fair.webp" type="image/webp">
            <img :class="classes" src="/images/used/autotrader/fair.png" alt="Autotrader rating - fair price">
        </picture>
    </div>
</template>

<script>
export default {
    props: {
        rating: {
            required: true,
        },
        classes: {
            required: false,
            default: function() { return { 'at-value-image': true }; },
        }
    }
}
</script>

<style scoped>
img {
    max-height: 33px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/AutoTraderValueRating.vue